import { render, staticRenderFns } from "./card-ticket-hxoff.vue?vue&type=template&id=70c2a060&scoped=true&"
import script from "./card-ticket-hxoff.vue?vue&type=script&lang=js&"
export * from "./card-ticket-hxoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2a060",
  null
  
)

export default component.exports